declare var $: any;

import { Autosave } from "./autosave"

export class TextInput {
    static init() {
        $("body").on("keypress", ".text-box-container input[type=text]:not(.js-autosave-off)",
            (e: KeyboardEvent) => {
                if (e.keyCode === 13 || e.which === 13) { // Enter key
                    e.preventDefault();

                    // this will cause focus to move to next text input after autosave
                    const nextIndex = Autosave.getAllInputs().index($(e.target)) + 1;
                    Autosave.triggerInstantSave(nextIndex);
                }
            });
    };
};



// WEBPACK FOOTER //
// ./assets/scripts/modules/textInput.ts